import { getLogger } from '@logtape/logtape';
import { AxiosResponse } from 'axios';

import { api } from '@/lib/api-client.ts';

import { Customer } from '@/models/customers/Customer.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { serializeApiError } from '@/utils/log-utils.ts';

const logger = getLogger(['service', 'customer']);

interface GetResponse {
    data: Customer[];
}

const getCustomers = async (customer_id: string): Promise<Customer[] | undefined> => {
    try {
        const response: AxiosResponse<GetResponse> = await api.get(
            ServiceUrl.ADMIN_API_DOMAIN.CUSTOMERS_API.CUSTOMERS,
            {
                headers: {
                    customer_id: customer_id,
                },
            }
        );

        return response.data?.data;
    } catch (error) {
        logger.error('Failed to fetch the customers', { error: error, ...serializeApiError(error) });
        return undefined;
    }
};

export const getLocationKeyMap = async (customer_id: string): Promise<Map<string, string> | undefined> => {
    const customers = await getCustomers(customer_id);
    if (!customers) return undefined;

    const location_key_map = new Map<string, string>();
    for (const customer of customers) {
        for (const location of customer.locations) {
            if (!location.prismic_key || !location.id) continue;

            location_key_map.set(location.id, location.prismic_key);
        }
    }

    return location_key_map;
};
